export default "__VITE_ASSET__DlzQQL2v__"